import { SafeHtml, SafeScript, SafeStyle } from '@angular/platform-browser'

export class InfocardModel {

    constructor() {
        this.dis = 2
    }

    id: string
    tit: string
    htm: string
    js: string
    css: string
    codc: string
    cnf: any
    grp: number
    sty: string
    cls: string
    styp: string
    clsp: string
    srt: number
    ssty: SafeStyle
    shtm: SafeHtml
    dis: number

    chtm_id: string
    chart_id: string
}